var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"custom-bounce"}},[(_vm.show)?_c('v-progress-circular',{staticClass:"progress",attrs:{"width":3,"color":"primary","indeterminate":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }